export default __webpack_public_path__ + "static/media/unsplash_cameronStewart_suzzallo.176a0627.jpg";